
(() => {
  const node = document.getElementById('bragado-upsell-config');

  if (!node || customElements.get('bragado-cart-offer')) return;

  const config = JSON.parse(node.textContent);
  const t = config.text;
  const root = window.Shopify?.routes?.root || '/';

  const PRICES = [5500, 6000];

  const escape = value =>
    String(value).replace(/[&<>"']/g, c => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[c]));

  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      ...(data ? { body: JSON.stringify(data) } : {})
    });

    if (!response.ok) {
      throw new Error(t.error || 'Unable to update cart.');
    }

    return response.json();
  }

  function eligible(cart) {
    const item = cart.items?.[0];

    return Boolean(
      item &&
      cart.currency === 'USD' &&
      cart.item_count === 1 &&
      cart.items.length === 1 &&
      config.products.some(p => p.id === item.product_id) &&
      PRICES.includes(item.original_price) &&
      !item.selling_plan_allocation &&
      !Object.keys(item.properties || {}).length
    );
  }

  customElements.define(
    'bragado-cart-offer',
    class extends HTMLElement {

      connectedCallback() {
        this.refresh();
      }

      async refresh() {
        if (this.busy || this.loading) return;

        this.loading = true;

        try {
          const cart = await request('cart.js');

          if (!this.isConnected) return;

          if (!eligible(cart)) {
            this.hidden = true;
            this.replaceChildren();
            return;
          }

          const originalId = cart.items[0].variant_id;

          const products = await Promise.all(
            config.products
              .filter(p => p.id !== cart.items[0].product_id)
              .map(p => request('products/' + p.handle + '.js'))
          );

          const choices = products
            .map(p => ({
              ...p,
              variants: p.variants.filter(
                v => v.available && PRICES.includes(v.price)
              )
            }))
            .filter(p => p.variants.length);

          if (!this.isConnected || !choices.length) {
            this.hidden = true;
            return;
          }

          this.innerHTML = `
            <h3>COMPLETE THE FIT</h3>

            <p>
              Add another piece and unlock
              <strong>any 2 for $90.</strong>
            </p>

            ${choices.map(p => `
              <article>
                <img
                  src="${escape(p.featured_image || '')}${(p.featured_image || '').includes('?') ? '&' : '?'}width=160"
                  alt="${escape(p.title)}"
                  width="72"
                  height="88"
                  loading="lazy"
                >

                <div>
                  <h4>${escape(p.title)}</h4>

                  <div class="bragado-offer-controls">
                    <label
                      class="visually-hidden"
                      for="upsell-${p.id}"
                    >
                      ${escape(p.title)} ${escape(t.size)}
                    </label>

                    <select id="upsell-${p.id}">
                      <option value="">
                        ${escape(t.choose)}
                      </option>

                      ${p.variants.map(v => `
                        <option value="${v.id}">
                          ${escape(v.title)}
                        </option>
                      `).join('')}
                    </select>

                    <button
                      type="button"
                      data-add
                      disabled
                    >
                      ADD TO BUNDLE
                    </button>
                  </div>
                </div>
              </article>
            `).join('')}

            <p
              role="status"
              aria-live="polite"
              data-status
            ></p>

            <a href="${root}cart" data-review hidden>
              View cart
            </a>

            <small>
              Bundle discount applied automatically
              when eligible.
            </small>
          `;

          this.hidden = false;

          this.querySelectorAll('article').forEach(article => {
            const select = article.querySelector('select');
            const button = article.querySelector('[data-add]');

            select.addEventListener('change', event => {
              event.stopPropagation();
              button.disabled = !select.value;
            });

            button.addEventListener('click', () => {
              this.add(Number(select.value), originalId);
            });
          });

        } catch (error) {
          console.error('BRAGADO upsell:', error);
          this.hidden = true;
        } finally {
          this.loading = false;
        }
      }

      async add(variant, originalId) {
        if (this.busy || !variant) return;

        this.busy = true;

        const drawer = this.closest('cart-drawer');
        const status = this.querySelector('[data-status]');
        const review = this.querySelector('[data-review]');

        const buttons = [
          ...this.querySelectorAll('[data-add]')
        ];

        buttons.forEach(button => {
          button.disabled = true;
        });

        if (status) {
          status.textContent = 'Adding to cart...';
        }

        let added = false;

        try {
          const current = await request('cart.js');

          if (
            !eligible(current) ||
            current.items[0].variant_id !== originalId
          ) {
            throw new Error(
              'Your cart changed. Please try again.'
            );
          }

          // Add selected variant and request fresh drawer HTML.
          const sections = drawer.getSectionsToRender();

          const updated = await request('cart/add.js', {
            items: [
              {
                id: variant,
                quantity: 1
              }
            ],
            sections: sections.map(s => s.id),
            sections_url: window.location.pathname
          });

          added = true;

          // Shopify's cart/add response contains the added item(s),
          // not the full cart, so get the complete cart separately.
          const cart = await request('cart.js');

          if (
            cart.item_count !== 2 ||
            !cart.items.some(item => item.variant_id === variant)
          ) {
            throw new Error('Please review your cart.');
          }

          // Render the existing cart drawer using Shopify's sections.
          if (
            updated.sections &&
            Object.values(updated.sections).every(Boolean) &&
            typeof drawer.renderContents === 'function'
          ) {
            drawer.renderContents({
              ...cart,
              sections: updated.sections
            });
          } else {
            // Reliable fallback when theme section rendering fails.
            window.location.assign(root + 'cart');
            return;
          }

        } catch (error) {
          console.error('BRAGADO upsell:', error);

          if (status) {
            status.textContent = added
              ? 'Item added. View your cart to confirm.'
              : error.message;
          }

          if (review) {
            review.hidden = false;
          }

        } finally {
          this.busy = false;

          buttons.forEach(button => {
            button.disabled = added
              ? true
              : !button.closest('article')?.querySelector('select')?.value;
          });
        }
      }
    }
  );
})();
